import { VerifyState } from '../../store/state';
import { VerifyAction, VerifyActions } from '../actions/verify.action';

const initialState: VerifyState = {
  data: null,
  hasError: false,
  errorText: '',
  isLoading: false,
};

export default (state: VerifyState = initialState, action: VerifyAction) => {
  switch (action.type) {
    case VerifyActions.Verify:
      return {
        ...state,
        data: null,
        hasError: false,
        isLoading: true,
        errorText: '',
      };
    case VerifyActions.VerifySuccess:
      return {
        ...state,
        data: action.payload,
        verified: true,
        hasError: false,
        isLoading: false,
        errorText: '',
      };
    case VerifyActions.VerifyError:
      return {
        ...state,
        data: null,
        verified: false,
        hasError: true,
        isLoading: false,
        errorText: action.payload,
      };
    default:
      return state;
  }
};